import React, { Component } from 'react'
import GuessPigments from './Admin/GuessPigments'
import axios from 'axios';
import classNames from 'classnames'

class Admin extends Component {

    constructor(props) {
        super(props)

        const RED = 'Cadmium Red'
        const ORANGE = 'Cadmium Orange'
        const OCHRE = 'Yellow Ochre'
        const YELLOW = 'Cadmium Yellow'
        const GREEN = 'Sap Green'
        const TURQUOISE = 'Turquoise'
        const BLUE = 'Cobalt Blue'
        const VIOLET = 'Cobalt Violet'
        const CRIMSON = 'Alizarin Crimson'

        const UMBER = 'Raw Umber'
        const WHITE = 'Titanium White'
        const BLACK = 'Ivory Black'

        this.state = {
            pigments: [
                RED,
                ORANGE,
                OCHRE,
                YELLOW,
                GREEN,
                TURQUOISE,
                BLUE,
                VIOLET,
                CRIMSON,
                UMBER,
                WHITE,
                BLACK
            ],
            selectedPigments: [],
            selectedHue: 0,
            selectedValue: 0,
            selectedSaturation: 0,
            selectedQuadrant: 0,
            selectedHex: '#ffffff',
            numOfHues: 20,
            hueMultiplier: 36,
            // matrix[h][v][s]
            matrix: [],
            loading: true,
            pigmentExceptions: []
        }

        this.setSelectedPigments = this.setSelectedPigments.bind(this);
        this.generateMatrix = this.generateMatrix.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangePigment = this.handleChangePigment.bind(this);
        this.prevHue = this.prevHue.bind(this);
        this.nextHue = this.nextHue.bind(this);
    }

    componentDidMount() {
        this.generateMatrix();
    }

    generateMatrix() {
        var _this = this;
        let matrix = [];
        let matrixQuadrant = [];
        for (var hue = 0; hue < this.state.numOfHues; hue++) {
            matrix.push([[],[],[],[],[],[],[],[],[],[],[]]);
            matrixQuadrant.push([[],[],[],[],[],[],[],[],[],[],[]]);
        }

        var hueMultiplier = Math.round(360 / this.state.numOfHues);
        this.setState({ hueMultiplier: hueMultiplier })

        for (hue = 0; hue < this.state.numOfHues; hue++) {
            for (var v = 0; v <= 10; v++) { 
                for (var s = 0; s <= 10; s++) { 
                    //this.requestPigments({h: hue, s: s, v: v})
                    let guessPigments = new GuessPigments();
                    let quadrant = guessPigments.getColorQuadrant(hue * hueMultiplier, s * 10, v * 10)
                    let huePigments = guessPigments.getHuePigments(hue * hueMultiplier, quadrant, s * 10, v * 10)
                    let neutralPigments = guessPigments.getNeutralPigments(hue * hueMultiplier, quadrant, v * 10, s * 10)

                    let pigments = {
                        ...huePigments,
                        ...neutralPigments
                    };
                    matrix[hue][v][s] = Object.keys(pigments);
                    matrixQuadrant[hue][v][s] = quadrant;
                };
            };
        }

        _this.setState({ 
            matrix: matrix,
            matrixQuadrant: matrixQuadrant,
            loading: false 
        })
    }

    requestPigments(hsv) {
        var _this = this;

        axios.get(
                //'http://localhost:5001/alerionart-192803/us-central1/getPigments', 
                'https://us-central1-alerionart-192803.cloudfunctions.net/getPigments',
                {
                    params: {
                        hue: hsv.h * this.state.hueMultiplier,
                        value: hsv.v * 10,
                        saturation: hsv.s * 10
                    }
                }
            )
            .then(function (response) {
                let matrix = _this.state.matrix;
                let pigments = {
                    ...response.data.huePigments,
                    ...response.data.neutralPigments
                };
                matrix[hsv.h][hsv.v][hsv.s] = Object.keys(pigments);
                _this.setState({ matrix: matrix })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    setSelectedPigments(h, s, v) {
        let color = window.Color( { h: h * this.state.hueMultiplier, s: s * 10, v: v * 10 })
        let guessPigments = new GuessPigments();
        this.setState({ 
            selectedPigments: this.state.matrix[h][v][s],
            selectedSaturation: s,
            selectedValue: v,
            selectedQuadrant: guessPigments.getColorQuadrant(h * this.state.hueMultiplier, s * 10, v * 10),
            selectedHex: color.toString()
        })
    }

    handleChange(e) {
        this.setState({ selectedHue: e.target.value});
    }

    handleChangePigment(e) {
        let matrix = this.state.matrix;
        let pigments = matrix[this.state.selectedHue][this.state.selectedValue][this.state.selectedSaturation];
        let newPigment = e.target.value;

        let exists = pigments.indexOf(newPigment);
        if (e.target.checked && exists === -1) {
            // Add it
            pigments.push(newPigment)
        } else if (!e.target.checked && exists > -1) {
            // Remove it
            pigments.splice(exists, 1);
        }

        matrix[this.state.selectedHue][this.state.selectedValue][this.state.selectedSaturation] = pigments;
        this.setState({ 
            matrix: matrix,
            selectedPigments: pigments 
        });

        // Generate Exceptions Output

    }

    prevHue() {
        let hue = this.state.selectedHue - 1;
        if (hue >= 0) {
            this.setState({ selectedHue: hue })
        }
    }

    nextHue() {
        let hue = this.state.selectedHue + 1;
        if (hue < this.state.numOfHues) {
            this.setState({ selectedHue: hue })
        }
    }

    render() {
        var checked = false;
        if (this.state.loading) {
            return (
                <div>
                    Loading
                </div>
            )
        } else {
            return (
                <div className="flex flex-col h-screen">
                    <div className="flex-grow">
                        <div>
                            <div className="mt-4 mx-auto max-w-screen-xl px-4 sm:px-6 md:mt-16 lg:mt-20">
                                <div className="">
                                    <h2 className="text-center mb-4 text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
                                        Admin Utility
                                    </h2>
                                    <div className="flex">
                                        <div className="flex-shrink">
                                            <div className="">
                                            {
                                                this.state.matrix.map((hue, hueIndex) => (
                                                    <div className={(this.state.selectedHue === hueIndex) ? 'block' : 'hidden'} key={hueIndex}>
                                                    {
                                                        hue.map((value, valueIndex) => (
                                                            <div className="flex" key={'value='+valueIndex+'hue='+hueIndex}>
                                                            {
                                                                value.map((saturation, saturationIndex) => {
                                                                    let color = window.Color( { h: hueIndex * this.state.hueMultiplier, s: saturationIndex * 10, v: valueIndex * 10 })
                                                                    return (
                                                                        <div className="flex flex-col text-white text-center cursor-pointer m-1 h-12 w-12" key={'value='+valueIndex+'saturation='+saturationIndex+'hue='+hueIndex} data-h={hueIndex * this.state.hueMultiplier} data-s={saturationIndex * 10} data-v={valueIndex * 10}
                                                                            onClick={ () => this.setSelectedPigments(hueIndex, saturationIndex, valueIndex) }
                                                                            style={{ backgroundColor: color.toString() }}>
                                                                                {this.state.matrixQuadrant[hueIndex][valueIndex][saturationIndex]}
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                            </div>
                                                        )).reverse()
                                                    }
                                                    </div>
                                                ))
                                            }
                                            </div>
                                            <div className="flex justify-between">
                                                <button className={classNames([(this.state.selectedHue === 0) ? 'opacity-25' : '', 'cursor-pointer', 'py-2', 'px-4', 'border', 'border-transparent', 'text-sm', 'font-bold', 'rounded-md', 'text-white', 'bg-gray-600', 'hover:bg-gray-500', 'focus:outline-none', 'focus:border-gray-700', 'focus:shadow-outline-gray', 'active:bg-gray-700', 'transition duration-150', 'ease-in-out'])} onClick={this.prevHue}>
                                                    Prev Hue
                                                </button>
                                                <div className="">Hue: {this.state.selectedHue * this.state.hueMultiplier}</div>
                                                <button className={classNames([(this.state.selectedHue === this.state.numOfHues - 1) ? 'opacity-25' : '', 'cursor-pointer', 'py-2', 'px-4', 'border', 'border-transparent', 'text-sm', 'font-bold', 'rounded-md', 'text-white', 'bg-gray-600', 'hover:bg-gray-500', 'focus:outline-none', 'focus:border-gray-700', 'focus:shadow-outline-gray', 'active:bg-gray-700', 'transition duration-150', 'ease-in-out'])} onClick={this.nextHue}>
                                                    Next Hue
                                                </button>
                                            </div>
                                        </div>
                                        <div className="pl-20">
                                            <div className="flex">
                                                <div>
                                                    <h3 className="font-bold mb-4">Pigments Estimate</h3>
                                                    <div>
                                                    {
                                                        this.state.pigments.map((pigment, index) => {
                                                            if (this.state.selectedPigments.find(pig => pig === pigment)) {
                                                                checked = true;
                                                            } else {
                                                                checked = false;
                                                            }
                                                            return (
                                                                <div key={index} className="flex items-center">
                                                                    <input 
                                                                        id={pigment + '-input'} 
                                                                        value={pigment}
                                                                        type="checkbox" 
                                                                        className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                                                                        checked={checked} 
                                                                        onChange={(e) => this.handleChangePigment(e)} />
                                                                    <label htmlFor={pigment + '-input'} className="ml-2 block text-sm leading-5 text-gray-900">
                                                                        { pigment }
                                                                    </label>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    </div>
                                                    <h3 className="font-bold my-4">Selected Color</h3>
                                                    <div>
                                                        Hue: {this.state.selectedHue * this.state.hueMultiplier}<br />
                                                        Saturation: {this.state.selectedSaturation * 10}<br />
                                                        Value: {this.state.selectedValue * 10}<br />
                                                        Quadrant: {this.state.selectedQuadrant}
                                                    </div>
                                                    <div className="m-1 h-12 w-12"
                                                        style={{ backgroundColor: this.state.selectedHex }}>
                                                    </div>
                                                    <div className="shadow bg-gray-300">
                                                        {this.state.changedValues}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className="mt-20 flex">
                                        <div>
                                            <h3 className="font-bold my-4">Pigment Calculation</h3>
                                            Dark Neutral = Umber or Black depending on Hue<br />
                                            Quadrant 1: White, Umber<br />
                                            Quadrant 2: Hue, White, Dark Neutral<br />
                                            Quadrant 3: Hue, White, Dark Neutral<br />
                                            Quadrant 4: Hue, White<br />
                                            Quadrant 5: Hue, Dark Neutral<br />
                                            Quadrant 6: Hue, Dark Neutral<br />
                                            Quadrant 7: Black,
                                            Quadrant 8: Straight from the Tube
                                        </div>
                                        <div className="mx-10">
                                            <h3 className="font-bold my-4">Hue Calculation</h3>
                                            None of your business
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >
                </div>
            );
        }
    }
}

export default Admin;